import graphqlHelperService from "./graphqlHelper.service";
import { CourseDetail } from "../types/course";
import { RegisterCourse } from "../types/registerCourse";
import { Role } from "../types/enum";

export const courseDetailService = {
    courseDetailRegister: async (course: RegisterCourse, discountCode?: string): Promise<CourseDetail> => {
        const apolloResult = await graphqlHelperService.sendQuery(
            courseDetailRegisterQuery,
            {
                categoryId: course.category?.categoryId,
                courseId: course.type?.courseId,
                place: course.place ? course.place : undefined,
                locationCode: course.date?.locationCode,
                discountCode: discountCode ? discountCode : undefined,
            }
        );
        return apolloResult.courseDetail as CourseDetail;
    },
    courseDetails: async (studentId?: string, role?: string): Promise<CourseDetail[]> => {
        const apolloResult = await graphqlHelperService.sendQuery(
            courseDetailsQuery(studentId, role)
        );
        return apolloResult.courseDetails as CourseDetail[];
    },
    courseDetailsAdmin: async (): Promise<CourseDetail[]> => {
        const apolloResult = await graphqlHelperService.sendQuery(
            courseDetailsAdminQuery()
        );
        return apolloResult.courseDetails as CourseDetail[];
    }
}

const courseDetailRegisterQuery = `query CourseDetailRegister($categoryId: Int, $courseId: String, $place: String, $locationCode: String, $discountCode: String) {
    courseDetail(categoryId: $categoryId, courseId: $courseId, place: $place, locationCode: $locationCode, discountCode: $discountCode)
    {
        category
        type
        address
        zipCode
        place
        dates 
        examDate 
        eLearning
        price
        isHomeStudy
        showHomework
        showSampleExam
        btw
        certificate
        exam
        timeSpan
        frequency
        locations
        rating
        homeworkSupport
        locationName
        freeField1
        freeField1Caption
        freeField1Icon
        freeField2
        freeField2Caption
        freeField2Icon
    }
}`;

const participatingStudentsBlock = `
        participatingStudents {
            studentId
            firstName
            prefix
            lastName
            passed
            failed
            madeHomeWork
            madeSampleExams
            sampleExamGrade
            presentAtExam
        }`;

const courseDetailsQuery = (studentId?: string, role?: string) => `query{
    courseDetails ${studentId ? `(studentId: ${studentId})` : ``}  {
        categoryId
        courseId
        projectId
        registrationDate
        category
        type
        address
        zipCode
        place
        locationName
        dates 
        examDate 
        exam
        certificate
        timeSpan
        homeworkSupport
        eLearning
        eLearningLink
        passed
        failed
        isHomeStudy
        amountOfParticipants
        showHomework
        showSampleExam
        showExamResultButton
        madeHomeWork
        madeSampleExams
        sampleExamGrade
        dateDone
        grade
        presentAtExam
        theoreticGrade
        portfolioGrade
        coachingGrade
        expired
        freeField1
        freeField1Caption
        freeField1Icon
        freeField2
        freeField2Caption
        freeField2Icon${role === Role.COMPANY ? participatingStudentsBlock : ``}
    }
}`;

const courseDetailsAdminQuery = () => `query{
    courseDetails {
        courseId
        course
        googleAnalyticsUrl
    }
}`;
